module.exports = __webpack_public_path__ + "img/gera3.jpg";